import { useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { notificationApiRef } from '../notificationApiRef';
import { WEBHOOKS_KEY } from './reactQuery';
import { WebhooksGetRequest } from '@agilelab/plugin-wb-notification-common';

export const useWebhooks = (
  params?: WebhooksGetRequest,
  options?: { enabled?: boolean },
) => {
  const notificationApi = useApi(notificationApiRef);
  return useQuery({
    queryKey: [WEBHOOKS_KEY, params],
    queryFn: () => notificationApi.getWebhooks(params ?? {}),
    enabled: options?.enabled,
  });
};
